export const findCookie = name => {
  if (!document.cookie) {
    return null
  }

  const csrfCookies = document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(c => c.startsWith(name + '='))

  if (csrfCookies.length === 0) {
    return null
  }

  return decodeURIComponent(csrfCookies[0].split('=')[1])
}
